<!--
component: BrowseBuildingDairi
author: Ken Nakamura
description: 建築計画概要書（第一面 代理者）
-->
<template>
  <section>
    <div class="gaiyo-row">
      <div class="gaiyo-major-title">【2.代理者】</div>
    </div>
    <div v-for="(dairi, index) in dairis" :key="index">
      <hr v-show="index>0">
      <div class="gaiyo-row">
        <div class="gaiyo-minor-title">【ｲ.資格】</div>
        <div class="gaiyo-element left-40">&nbsp;&nbsp;（{{getShikaku(dairi.drsY_SKK_SKBT)}}</div>
        <div class="gaiyo-element left-65">）建築士</div>
        <div class="gaiyo-element left-90">（{{getRegister(dairi.drsY_TRK_KKN)}}</div>
        <div class="gaiyo-element left-115">&nbsp;）登録第&nbsp;{{dairi.drsY_TRK_NO}}&nbsp;号</div>
      </div>
      <div class="gaiyo-row">
        <div class="gaiyo-minor-title">【ﾛ.氏名】</div>
        <div class="gaiyo-element left-45">{{dairi.drsY_NAME}}</div>
      </div>
      <div class="gaiyo-row">
        <div class="gaiyo-minor-title">【ﾊ.建築士事務所名】</div>
        <div class="gaiyo-element left-40">&nbsp;&nbsp;（{{getShikaku(dairi.drjM_SKK_SKBT)}}</div>
        <div class="gaiyo-element left-65">）建築士事務所</div>
        <div class="gaiyo-element left-90">（{{getRegister(dairi.drjM_TRK_KKN)}}</div>
        <div class="gaiyo-element left-115">&nbsp;）登録第&nbsp;{{dairi.drjM_TRK_NO}}&nbsp;号</div>
      </div>
      <div class="gaiyo-row">
        <div class="gaiyo-element left-45">{{ dairi.drjM_NAME }}
        </div><br>
        <div v-for="(n,index) in wordwrap(dairi.drjM_NAME,40)" :key="`drjm-name-${index}`">
          <br v-show="index>0"></div>
      </div>
      <div class="gaiyo-row">
        <div class="gaiyo-minor-title">【ﾆ.郵便番号】</div>
        <div class="gaiyo-element left-45">{{dairi.drjM_POSTNO}}</div>
      </div>
      <div class="gaiyo-row">
        <div class="gaiyo-minor-title">【ﾎ.所在地】</div>
        <div class="gaiyo-element left-45">{{dairi.drjM_ADDR}}</div>
        <div v-for="(n,index) in wordwrap(dairi.drjM_ADDR,40)" :key="`drjm-addr-${index}`">
          <br v-show="index>0"></div>
      </div>
      <div class="gaiyo-row">
        <div class="gaiyo-minor-title">【ﾍ.電話番号】</div>
        <div class="gaiyo-element left-45">{{dairi.drjM_TELNO}}</div>
      </div>
    </div>
  </section>
</template>

<script>
import constants from '../../common/constants'

export default {
  props: {
    dairis: {
      type: Array,
      default: () => [],
    }
  },
  computed: {
  },
  methods: {
    getShikaku(code) {
      const shikaku = constants.shikakuKubun[code];
      if (shikaku == null) {
        return '';
      }
      else {
        return shikaku.name;
      }
    },
    getRegister(code) {
      const rgst = constants.Register[code];
      if (rgst == null) {
        return '';
      }
      else {
        return rgst.name;
      }
    },
    wordwrap(text, len) {
      let result = [];
      if (text && text.length) {
        let start = 0;
        for (let i = 0; i < text.length; i += len) {
          result.push(text.substr(start, len));
          start += len;
        }
      }
      return result;
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../styles/common/common.css";
</style>